import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import FilterGroup from '../FilterGroup';
import CheckBox from '../../../ui/form/form-checkbox';

const SHOW_RENTAL_TYPE_SHORT = 'shortTerm';
const SHOW_RENTAL_TYPE_MID = 'midTerm';
const SHOW_RENTAL_TYPE_LONG = 'longTerm';

const RentalTypeFilters = ({
  onHandleToggleCheckbox,
  isValueChecked,
  rentalFilter,
  renderInfoToolTip
}) => {
  const isRentalTypeChecked = rentalType => {
    return isValueChecked(rentalFilter, rentalType);
  };

  const updateRentalTypeFilters = rentalType => isChecked => {
    onHandleToggleCheckbox('rentalType[]', rentalType, isChecked);
  };

  return (
    <FilterGroup
      classModifier="property-type-checkboxes"
      label={trans('search.filter.rental-type')}
      tooltip={() =>
        renderInfoToolTip(
          <span className="search-filter-tooltip">
            {trans('search.filter.rental.type.tooltip')}
          </span>
        )
      }
    >
      <CheckBox
        id="rentalType-short"
        label={trans('search.filter.rentalType.text.short')}
        onChange={updateRentalTypeFilters(SHOW_RENTAL_TYPE_SHORT)}
        soyuzTracking={{
          eventCategory: 'Search',
          eventAction: 'rental type filter',
          eventLabel: `${SHOW_RENTAL_TYPE_SHORT} checked`
        }}
        checked={isRentalTypeChecked(SHOW_RENTAL_TYPE_SHORT)}
      />
      <CheckBox
        id="rentalType-mid"
        label={trans('search.filter.rentalType.text.mid')}
        onChange={updateRentalTypeFilters(SHOW_RENTAL_TYPE_MID)}
        soyuzTracking={{
          eventCategory: 'Search',
          eventAction: 'rental type filter',
          eventLabel: `${SHOW_RENTAL_TYPE_MID} checked`
        }}
        checked={isRentalTypeChecked(SHOW_RENTAL_TYPE_MID)}
      />
      <CheckBox
        id="rentalType-long"
        label={trans('search.filter.rentalType.text.long')}
        onChange={updateRentalTypeFilters(SHOW_RENTAL_TYPE_LONG)}
        soyuzTracking={{
          eventCategory: 'Search',
          eventAction: 'rental type filter',
          eventLabel: `${SHOW_RENTAL_TYPE_LONG} checked`
        }}
        checked={isRentalTypeChecked(SHOW_RENTAL_TYPE_LONG)}
      />
    </FilterGroup>
  );
};

RentalTypeFilters.propTypes = {
  rentalFilter: PropTypes.string.isRequired,
  onHandleToggleCheckbox: PropTypes.func.isRequired,
  isValueChecked: PropTypes.func.isRequired,
  renderInfoToolTip: PropTypes.func.isRequired
};

export default RentalTypeFilters;
